const videoCategory = () => import('@/pages/video/category/index.vue');

export default [{
    path: '/video/category',
    component: videoCategory,
    meta: [{
        name: '视频管理',
		activeRoute: '/video/manage'
    },
    {
        name: '视频分类',
        activeRoute: '/video/category'
    }]
}];